export default __webpack_public_path__ + "static/home-new-a81a91c7623f1252872f562f62c062f4.png";